export default "__VITE_ASSET__Cb6CX$dL__"